import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { useAsyncData } from "@/lib/useAsyncData";
import { ReportLoading } from "@/components/leasing/ReportState";
import { fmtNumber, fmtDate, fmtMonth } from "@/lib/format";

export default function PolicyAllocationDialog({ policy, open, onOpenChange }) {
  const { loading, data } = useAsyncData(async () => {
    const res = await api.get(`/prepaid/policies/${policy.id}/allocation`);
    return res.data;
  }, [policy.id]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col" data-testid="policy-allocation-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">
            Repartizare poliță {policy.nr_polita}
            <span className="text-sm font-normal text-slate-500 ml-2">{policy.insurer}</span>
          </DialogTitle>
          <DialogDescription className="sr-only">Repartizarea lunară a poliței între data început și data sfârșit.</DialogDescription>
        </DialogHeader>

        {loading && !data ? <ReportLoading label="Se calculează…" /> : data && (
          <div className="overflow-auto flex-1 space-y-3">
            <div className="flex flex-wrap gap-4 text-sm bg-slate-50 rounded p-3">
              <span>Valoare RON: <b className="tabular">{fmtNumber(data.policy.value_ron)}</b></span>
              <span>Val. zilnică: <b className="tabular">{fmtNumber(data.policy.daily_value, 4)}</b></span>
              <span>{fmtDate(data.policy.data_inceput)} → {fmtDate(data.policy.end_date)} ({data.policy.nr_zile} zile)</span>
            </div>
            <table className="w-full text-sm jh-table border rounded">
              <thead className="bg-slate-100 sticky top-0">
                <tr>
                  <th className="text-left px-3 py-2">Lună</th>
                  <th className="text-center px-3 py-2">Zile în lună</th>
                  <th className="text-right px-3 py-2">Repartizat</th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((r) => (
                  <tr key={r.month} className="hover:bg-slate-50">
                    <td className="px-3 py-1.5">{fmtMonth(r.month)}</td>
                    <td className="px-3 py-1.5 text-center tabular">{r.days}</td>
                    <td className="px-3 py-1.5 text-right tabular">{fmtNumber(r.allocated)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
